import React from "react";

export default function Footer() {
  return (
    <footer className="gd-footer">
      <div className="gd-footer-inner">
        <div className="gd-footer-brand">
          <span className="gd-footer-dot" />
          <span>GestDoc</span>
          <span className="gd-footer-sep">·</span>
          <span className="gd-footer-muted">© {new Date().getFullYear()}</span>
        </div>

        <nav className="gd-footer-nav" aria-label="Ayuda">
          <a href="https://gestdoc.cl/" target="_blank" rel="noopener noreferrer">
            Sobre GestDoc
          </a>
          <a href="https://gestdoc.cl/contacto/" target="_blank" rel="noopener noreferrer">
            Contacto
          </a>
        </nav>

        <div className="gd-footer-contact">
          <a href="mailto:contacto@gestdoc.cl" className="gd-footer-link">
            contacto@gestdoc.cl
          </a>
          <span className="gd-footer-sep">·</span>
          <a href="tel:+56984844444" className="gd-footer-link">
            +56 9 8484 4444
          </a>
        </div>
      </div>
    </footer>
  );
}
